<template>
    <div class="voiceCompose-container">
        <div class="header">
            <div class="title">语音合成 </div>
        </div>
        <div class="content">
            <div class="left-container">
                <ul>
                    <li @click="voiceIndex = index" v-for="(item, index) in voiceList" :key="item.id" :class="{on: voiceIndex == index}">
                        <div :class="{left: true, cn: item.language == '中文', en: item.language == '英文', jp: item.language == '日文'}"></div>
                        <div class="right">
                            <div class="l">
                                <div @click.stop="previewAudio(item.preview_url)" :class="{avater: true, cnm: item.language == '中文' && item.sex == '男', cnf: item.language == '中文' && item.sex == '女', enm: item.language == '英文' && item.sex == '男', enf: item.language == '英文' && item.sex == '女', jpf: item.language == '日文' && item.sex == '女'}"></div>
                                <div :title="item.name" class="title">{{ item.name }}</div>
                            </div>
                            <div class="r">{{ item.language }}</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="right-container">
                <div class="top-container">
                    <span>名称: </span>
                    <input v-model="title" placeholder="未命名报道" type="text">
                </div>
                <div class="center-container">
                    <div @keyup="clearFont" ref="content" class="writeContent" maxlength="1500" contenteditable="true"></div>
                </div>
                <div class="bottom-container">
                    <div class="left-container">
                        <div class="speed">
                            <p>朗读速度: </p>
                            <div class="speedList">
                                <div @click="showSpeed = !showSpeed" class="speedInput">
                                    <span>{{speed}}</span>
                                    <img :class="{rotate: showSpeed}" src="@assets/img/common/down.png" alt="">
                                </div>
                                <ul v-if="showSpeed" v-click-outside="closeSpeed">
                                    <li @click="speed = item.name;speedIndex = index;showSpeed = false" v-for="(item,index) in speedList" :key="index">{{item.name}}</li>
                                </ul>
                            </div>
                            <!-- <p>秒</p> -->
                        </div>

                        <div class="btnList">
                            <div class="insertStop">
                                <div :class="{on: showStop}" @click="showStop = !showStop">插入停顿</div>
                                <ul v-if="showStop" v-click-outside="closeStop">
                                    <li @click="stop = item.pause;setPause()" v-for="(item,index) in stopList" :key="index">{{item.name}}</li>
                                </ul>
                            </div>
                            <div class="insertWord">
                                <div :class="{on: showWord}" @click="insertSpell()">插入多音字</div>
                            </div>
                            <div class="insertNum">
                                <div :class="{on: showNum}" @click="insertNum()">标注数值</div>
                                <ul v-if="showNum" v-click-outside="closeNum">
                                    <li @click="num = item.num;setNum()" v-for="(item,index) in numList" :key="index">{{item.name}}</li>
                                </ul>
                            </div>
                            <div class="help">
                                <i></i>
                                <div class="content">
                                    <img src="@assets/img/anchor/trangle.png" alt="">
                                    <span>eg:2008</span>
                                    <span>【数值】二千零八，【数字】二零零八</span>
                                </div>
                            </div>
                            <!-- <div class="line"></div>
                            <div class="insertNum">
                                <div :class="{on: showEmoji}" @click="showEmoji = !showEmoji">插入动作</div>
                                <div v-if="showEmoji" @mousewheel="Wheel" @DOMMouseScroll="FireWheel" v-click-outside="closeEmoji" :class="{'emoji-container': true,right: posRight}">
                                    <ul>
                                        <li @mouseenter="bgToGif(index)" @mouseleave="gifToBg(index)" v-for="(item,index) in emojiList" :key="index" @click="setEmoji(item.value,index)">
                                            <div :style="'background-image: url('+item.showBg+')'" class="bg"></div>
                                            <div class="notice">
                                                <img src="@assets/img/anchor/trangle.png" alt="">
                                                <span>{{item.title}}</span>
                                            </div>
                                        </li>
                                    </ul>
                                    <div class="point">
                                        <p :data-index="index" v-for="index of emojiPage.page_count" @click="emojiIndex = index;getAnchorEmoji(anchorId)" :key="index" :class="{on: emojiIndex == index}"></p>
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    <div class="right-container">
                        <i></i>
                        <div class="content">
                            请选中文字后插入多音字或标注数值
                        </div>
                        <div @click="compose" class="submit"><i></i><span>合成</span></div>
                        <div @click=save class="save"><i></i><span>保存</span></div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="showWord" class="wordInput-bg">
            <div class="wordInput-container">
                <p>多音字</p>
                <div class="input-container">
                    <div v-for="(item,index) in textArr" :key="index" class="input">
                        <span>{{item.name}}</span>
                        <input style="ime-mode:disabled" @input="item.value=item.value.replace(/[\u0391-\uFFE5]/gi,'')" v-model="item.value" placeholder="请输入拼音" type="text">
                        <div class="sb">
                            <p :class="{on: item.status}" @click="setStatus(index)">
                                <span>{{item.voiceName}}</span>
                                <img  :class="{rotate: item.status}" src="@assets/img/anchor/downArrow.png" alt="">
                            </p>
                            <ul :style="'top:'+top+'px'" v-if="item.status">
                                <li @click="item.voiceName = items;item.status=false" v-for="(items,indexs) in sbList" :key="indexs">{{items}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="btn">
                    <p @click="showWord = false">取 消</p>
                    <p :title="!canConfirm ? '您有拼音尚未输入' : ''" @click="spellConfirm" :class="{on:true,op: !canConfirm}">确 认</p>
                </div>
            </div>
        </div>
        <audio ref="audio" :src="previewUrl"></audio>
        <div ref="filterContent" class="filterContent" contenteditable="true" style="position: absolute;top: -15000px"></div>
        <div v-show="isComposeSuccess" class="mask-container">
            <div class="success-container">
                <img src="../assets/img/common/success.png">
                <p>音频合成已提交</p>
                <span>请在我的素材中查看合成的音频</span>
                <div class="button">
                    <div @click="isComposeSuccess = false;windowClose()">确认</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vClickOutside from "v-click-outside";
import common from '@common/common'
import * as config from '@common/config'
export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    watch: {
        textArr: {
            deep: true,
            handler: function(n, o) {
                let length = this.textArr.length;
                let index = 0;
                this.textArr.forEach(el => {
                    if(el.value){
                        index ++
                    }
                })

                if(index == length){
                    this.canConfirm = true
                }else{
                    this.canConfirm = false
                }
            }
        }
    },
    data() {
        return {
            isComposeSuccess: false,
            previewUrl: '',
            title: '',
            canConfirm: false,
            showSpeed: false,
            showStop: false,
            showWord: false,
            showNum: false,
            voiceList: [],
            voiceIndex: 0,
            textArr: [],
            speedList: [
                {name: '1.5', spd: '+500'},
                {name: '1.2', spd: '+200'},
                {name: '1.0', spd: '0'},
                {name: '0.8', spd: '-200'},
                {name: '0.5', spd: '-500'}
            ],
            speed: '1.0',
            speedIndex: 2,
            stopList: [
                {name: '0.1秒', pause: 'p100'},
                {name: '0.2秒', pause: 'p200'},
                {name: '0.4秒', pause: 'p400'},
                {name: '0.6秒', pause: 'p600'},
                {name: '1.0秒', pause: 'p1000'}
            ],
            stop: '',
            numList: [
                {name: '数值', num: 'cardinal'},
                {name: '数字', num: 'digits'}
            ],
            num: '',
            sbList: ['第一声','第二声','第三声','第四声'],
            sb: '第一声',
            spellInput: ''
        }
    },
    methods: {
        windowClose() {
            window.close()
        },
        compose() {
            console.log(this.getInnerText())
            let info = {
                action: 'submit',
                title: this.title,
                content: this.getInnerText(),
                spd: this.speedList[this.speedIndex].spd,
                vid: this.voiceList[this.voiceIndex].id,
                id: this.$route.query.d ? this.$route.query.d  : ''
            }
            common.myFetch(config.apis.editMakeupAudio, info).then((r) => {
                if (r) {
                    console.log(r)
                    this.isComposeSuccess = true
                    // this.voiceList = r.list
                }
            })
        },
        save() {
            console.log(this.getInnerText())
            let info = {
                action: 'save',
                title: this.title,
                content: this.getInnerText(),
                spd: this.speedList[this.speedIndex].spd,
                vid: this.voiceList[this.voiceIndex].id,
                id: this.$route.query.d ? this.$route.query.d  : ''
            }
            common.myFetch(config.apis.editMakeupAudio, info).then((r) => {
                if (r) {
                    console.log(r)
                    this.$toast('音频合成信息已保存')
                    this.$router.push({
                        path: "/voiceCompose",
                        query: {
                            d: r
                        }
                    });
                    // this.voiceList = r.list
                }
            })
        },
        getInnerText() {
            this.$refs.filterContent.innerHTML = this.$refs.content.innerHTML;
            let contentEditOnSpan = document.querySelectorAll('.filterContent .contentEditOn')
            if(contentEditOnSpan){
                for (let index = 0; index < contentEditOnSpan.length; index++) {
                    const element = contentEditOnSpan[index];
                    let name = element.getAttribute('data-name')

                    if(name == 'say-as' || name == 'phoneme'){
                        if(element.previousSibling && element.previousSibling.nodeType){
                            if(element.previousSibling.nodeName == 'LABEL'){
                                element.innerText = element.previousSibling.innerText
                                element.previousSibling.remove()
                            }
                        }
                    }else{
                        if(element.parentNode){
                            if(element.parentNode.nodeName == 'LABEL'){
                                let u = element
                                this.afterinsert(u,element.parentNode)
                                // element.remove()
                            }
                        }
                    }
                    // console.log(name)
                }
                // console.log(contentEditOnSpan)
            }
            // console.log(this.$refs.filterContent.innerHTML)
            // let contentEditOnSpan = document.querySelectorAll('.filterContent .contentEditOnContainer')
            // if(contentEditOnSpan){
            //     for (let index = 0; index < contentEditOnSpan.length; index++) {
            //         const element = contentEditOnSpan[index];
            //         let contentEditOnSpan1 = element.querySelector('.contentEditOn')
            //         console.log(contentEditOnSpan1)
            //     }
            // }
            // this.$refs.filterContent.innerHTML = this.$refs.content.innerHTML;
            // let contentEditOnSpan = document.querySelectorAll('.filterContent .contentEditOn')
            // if(contentEditOnSpan){
            //     console.log(contentEditOnSpan)
            //     for (let index = 0; index < contentEditOnSpan.length; index++) {
            //         const element = contentEditOnSpan[index];
            //         element.innerHTML = element.dataset.name
            //     }
            // }

            let nullSpan = document.querySelectorAll('.filterContent span')

            if(nullSpan){
                for (let index = 0; index < nullSpan.length; index++) {
                    const element = nullSpan[index];
                    // console.log(element)
                    if(!element.getAttribute('class') && element.innerText == ''){
                        element.remove()
                    }
                }
            }

            return this.$refs.filterContent.innerHTML
            // console.log(this.$refs.filterContent.innerText)
        },
        previewAudio(url) {
            this.$refs.audio.src = url
            this.$refs.audio.load()
            this.$refs.audio.play()
        },
        getAnchorVoices() {
            let info = {}
            common.myFetch(config.apis.anchorVoices, info).then((r) => {
                if (r) {
                    console.log(r)
                    this.voiceList = r.list

                    if(this.$route.query.d){
                        this.getDetail()
                    }
                }
            })
        },
        getDetail() {
            let info = {
                id: this.$route.query.d
            }
            common.myFetch(config.apis.makeupAudioDetail, info).then((r) => {
                if (r) {
                    this.title = r.title
                    this.$refs.content.innerHTML = r.content
                    this.speedList.forEach((el,index) => {
                        if(el.spd == r.spd){
                            console.log(index)
                            this.speedIndex = index
                            this.speed = el.name
                        }
                    })

                    this.voiceList.forEach((el, index) => {
                        if(el.id == r.vid){
                            // console.log(index)
                            this.voiceIndex = index
                        }
                    })
                    // console.log(r)
                    // this.voiceList = r.list
                }
            })
        },
        clearFont() {
            let font = document.querySelectorAll('.writeContent font')
            if (font.length > 0) {
                for (let i = 0; i < font.length; i++) {
                    font[i].before(font[i].innerText)
                    font[i].remove()
                }
            }
        },
        spellConfirm() {

            if(!this.canConfirm) return

            let canSubmit = true;
            let str = ''
            let str1 = ''
            let arr = []
            this.textArr.forEach(el => {
                if(!el.value){
                    canSubmit = false;
                }else{
                    let spell = 1;
                    if (el.voiceName == '第一声') {
                        spell = 1;
                    } else if (el.voiceName == '第二声') {
                        spell = 2;
                    } else if (el.voiceName == '第三声') {
                        spell = 3;
                    } else if (el.voiceName == '第四声') {
                        spell = 4;
                    }
                    arr.push(el.value + spell)
                }
            })

            if(!canSubmit) return

            str = arr.join(',')

            str1 = arr.join(' ')

            let content = `<label class='on'>${this.saveStr}</label><span data-name="phoneme" data-value="${str1}" contenteditable="false" class="contentEditOn">${str}</span>`;

            // let content = `<span contenteditable="false" data-name="[=${this.spellInput}${spell}]" class="contentEditOn">音${this.spellInput}${spell}</span>`;
            this.showWord = false;
            this.spellInput = ''
            this.sb = '第一声'
            this.spell = 1
            this.insertSpell1(content)
        },
        insertSpell1(html) {
            this.range.deleteContents()
            var el = document.createElement('div')
            el.innerHTML = html
            var node
            var lastNode
            while ((node = el.firstChild)) {
                lastNode = this.frag.appendChild(node)
            } 
            this.range.insertNode(this.frag)
            if (lastNode) {
                this.range = this.range.cloneRange()
                this.range.setStartAfter(lastNode)
                this.range.collapse(true)
                this.sel.removeAllRanges()
                this.sel.addRange(this.range)
            }

            this.range = '';
            this.sel = '';
            this.frag = '';
        },
        setStatus(index) {
            let wordInputContainer = document.getElementsByClassName('wordInput-container')[0].getBoundingClientRect().top;
            let li = document.querySelectorAll('.wordInput-container .input-container .input')[index].getBoundingClientRect().top
            this.top = li - wordInputContainer + 42
            this.textArr.forEach((item,i) => {
                if(index == i){
                    if(item.status){
                        item.status = false
                    }else{
                        item.status = true
                    }
                }else{
                    item.status = false
                }
            })
        },
        closeSpeed() {
            this.showSpeed = false;
        },
        closeStop() {
            this.showStop = false;
        },
        closeNum() {
            this.showNum = false;
        },
        setNum() {
            // let date = new Date().getTime()
            let content = `<label class='on'>${this.saveStr}</label><span data-name="say-as" data-value="${this.num}" contenteditable="false" class="contentEditOn">${this.num == 'digits' ? '数字' : '数值' }</span>`;
            this.showNum = false;
            this.$refs.content.focus();
            this.insertHtml(content)
            this.saveInnerHtmlContent = this.$refs.content.innerHTML
        },
        setPause() {
            let sec = 0
            let sec1 = 0
            switch (this.stop) {
                case 'p100':
                    sec = 0.1
                    sec1 = 100
                    break;
                case 'p200':
                    sec = 0.2
                    sec1 = 200
                    break;
                case 'p400':
                    sec = 0.4
                    sec1 = 400
                    break;
                case 'p600':
                    sec = 0.6
                    sec1 = 600
                    break;
                case 'p1000':
                    sec = 1.0
                    sec1 = 1000
                    break;
                default:
                    break;
            }
            let content = `<span contenteditable="false" data-name="break" data-value="${Number(sec1)}ms" class="contentEditOn">停${sec}秒</span>`;
            this.showStop = false;
            this.$refs.content.focus();
            this.insertHtml(content)
            this.saveInnerHtmlContent = this.$refs.content.innerHTML
            // this.insertSpell1(content)
        },
        insertSpell() {
            // var sel, range, frag
            if (window.getSelection) {
                this.sel = window.getSelection()
                let str = this.sel
                str = str.toString()
                if(str.length > 0){
                    if (this.sel.getRangeAt && this.sel.rangeCount) {
                        this.range = this.sel.getRangeAt(0)
                        this.saveStr = str;
                        this.textArr = [];
                        let textArr = str.split('')
                        textArr.forEach(el => {
                            this.textArr.push({
                                name: el,
                                value: '',
                                voiceIndex: 0,
                                voiceName: '第一声',
                                status: false
                            })
                        })
                        this.frag = document.createDocumentFragment()
                        this.showWord = !this.showWord
                    }
                }else{
                    this.$MediaPlatformNotifyAuth({
                        title: '温馨提示',
                        msg: '您尚未选中任何文字!',
                        btn1: '取消',
                        btn2: '',
                        showIcon: false
                    })
                }
                
            }
        },
        insertNum() {
            // var sel, range, frag
            if (window.getSelection) {
                this.sel = window.getSelection()
                let str = this.sel
                str = str.toString()
                if(str.length > 0){
                    if (this.sel.getRangeAt && this.sel.rangeCount) {
                        this.range = this.sel.getRangeAt(0)
                        // console.log(this.range)
                        // let str = this.range.commonAncestorContainer.textContent.slice(this.range.startOffset, this.range.endOffset)
                        this.saveStr = str;
                        this.frag = document.createDocumentFragment()
                        this.showNum = !this.showNum
                    }
                }else{
                    this.$MediaPlatformNotifyAuth({
                        title: '温馨提示',
                        msg: '您尚未选中任何文字!',
                        btn1: '取消',
                        btn2: '',
                        showIcon: false
                    })
                }
                // console.log(this.sel.toString())
            }
        },
        insertHtml(html) {
            var sel, range, frag
            if (window.getSelection) {
                sel = window.getSelection()
                if (sel.getRangeAt && sel.rangeCount) {
                    range = sel.getRangeAt(0)
                    range.deleteContents()
                    var el = document.createElement('div')
                    el.innerHTML = html
                    frag = document.createDocumentFragment()
                    var node
                    var lastNode
                    while ((node = el.firstChild)) {
                        lastNode = frag.appendChild(node)
                    } range.insertNode(frag)
                    if (lastNode) {
                        range = range.cloneRange()
                        range.setStartAfter(lastNode)
                        range.collapse(true)
                        sel.removeAllRanges()
                        sel.addRange(range)
                        console.log(sel)
                    }
                }
            }
        },
        // move1() {
        //     console.log(123)
        //     let dom = document.querySelectorAll('.voiceCompose-container .header .title')[0]
        //     dom.classList.remove('show')
        //     // dom.style.opacity = 0
        //     this.$nextTick(() => {
        //         dom.classList.add('show')
        //     })
            
        // }
    },
    mounted() {
        this.getAnchorVoices()
    }
}
</script>

<style lang="less" scoped>
    @keyframes sho2w {
        0%{
            opacity: 1;
        }
        99%{
            opacity: 1;
        }
        100%{
            opacity: 0;
        }
    }

    .mask-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8)
    }

    .mask-container .success-container {
        position: absolute;
        top: 50%;
        left: 50%;
        margin-top: -145px;
        margin-left: -200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 400px;
        height: 290px;
        border-radius: 4px;
        background: #F9F9F9;
    }

    .mask-container .success-container img {
        width: 50px;
        height: 50px;
        margin-top: 40px;
    }

    .mask-container .success-container p {
        font-size: 20px;
        line-height: 26px;
        color: #050F0F;
        margin: 30px 0 14px;
    }

    .mask-container .success-container span {
        font-size: 14px;
        line-height: 18px;
        color: #829191;
    }

    .mask-container .success-container .button {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-top: 32px;
        cursor: pointer;
        user-select: none;
    }

    .mask-container .success-container .button div {
        width: 120px;
        height: 40px;
        background: #41B48C;
        line-height: 40px;
        text-align: center;
        border-radius: 30px;
        font-size: 14px;
        color: #FFFFFF;
    }
    .voiceCompose-container {
        display: flex;
        flex-direction: column;
        width: 100vw;
        height: 100vh;
        background: #E6EBF0;

        & > .header {
            display: flex;
            align-items: center;
            width: 100%;
            height: 72px;
            background: #F9F9F9;
            box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
            margin-bottom: 20px;

            .title {
                padding: 0 30px;
                box-sizing: border-box;
                font-size: 24px;
                color: #050F0F;
                font-weight: bold;
                // opacity: 0;

                // &.show {
                //     animation: sho2w 3s linear;
                // }
            }
        }

        & > .content {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            flex: 1;
            min-height: 0;
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;

            & > .left-container {
                width: 310px;
                height: 100%;
                background: #FCFEFF;
                box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
                border-radius: 4px;
                margin-right: 10px;
                padding: 20px 6px 20px 20px;
                box-sizing: border-box;

                ul {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    height: 100%;
                    overflow-y: auto;
                    overflow-x: hidden;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: #B9C3C3;
                        border-radius: 3px;
                        opacity: 0.5;
                    }

                    li {
                        display: flex;
                        width: 270px;
                        min-height: 50px;
                        background: rgba(185,195,195,0.15);
                        border-radius: 4px;
                        padding-right: 14px;
                        box-sizing: border-box;
                        user-select: none;
                        cursor: pointer;
                        margin-bottom: 10px;
                        border: 1px solid transparent;
                        box-sizing: border-box;

                        &:hover {
                            background: rgba(185,195,195,0.3);
                        }

                        &.on {
                            border: 1px solid #41B48C;
                            background: #E6F1ED;
                        }

                        .left {
                            width: 30px;
                            height: 30px;
                            margin-right: 10px;

                            &.cn {
                                background: url('../assets/img/voiceCompose/cn.png') no-repeat center center;
                                background-size: 100%;
                            }

                            &.en {
                                background: url('../assets/img/voiceCompose/en.png') no-repeat center center;
                                background-size: 100%;
                            }

                            &.jp {
                                background: url('../assets/img/voiceCompose/jp.png') no-repeat center center;
                                background-size: 100%;
                            }
                        }

                        .right {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            flex: 1;
                            min-width: 0;
                            height: 100%;

                            .l {
                                display: flex;
                                align-items: center;
                                flex: 1;
                                min-width: 0;
                                .avater {
                                    width: 40px;
                                    height: 40px;
                                    margin-right: 12px;

                                    &.cnf {
                                        background: url('../assets/img/voiceCompose/cnf.png') no-repeat center center;
                                        background-size: 100%;
                                    }

                                    &.cnm {
                                        background: url('../assets/img/voiceCompose/cnm.png') no-repeat center center;
                                        background-size: 100%;
                                    }

                                    &.enf {
                                        background: url('../assets/img/voiceCompose/enf.png') no-repeat center center;
                                        background-size: 100%;
                                    }

                                    &.enm {
                                        background: url('../assets/img/voiceCompose/enm.png') no-repeat center center;
                                        background-size: 100%;
                                    }

                                    &.jpf {
                                        background: url('../assets/img/voiceCompose/jpf.png') no-repeat center center;
                                        background-size: 100%;
                                    }
                                }

                                .title {
                                    flex: 1;
                                    min-width: 0;
                                    font-size: 16px;
                                    color: #000000;
                                    font-weight: bold;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                }
                            }

                            .r {
                                font-size: 14px;
                                color: #829191;
                            }
                        }
                    }
                }
            }

            & > .right-container {
                display: flex;
                flex-direction: column;
                flex: 1;
                min-width: 0;
                height: 100%;
                background: #FCFEFF;
                box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
                border-radius: 4px;
                overflow: hidden;

                .top-container {
                    display: flex;
                    align-items: center;
                    width: 100%;
                    height: 58px;
                    background: #FFFFFF;
                    box-shadow: 4px 4px 10px 0px rgba(5,10,15,0.05);
                    border-radius: 4px 4px 0px 0px;
                    padding: 0 20px;
                    box-sizing: border-box;

                    span {
                        font-size: 14px;
                        color: #050F0F;
                        margin-right: 8px;
                    }

                    input {
                        width: 400px;
                        height: 34px;
                        font-size: 14px;
                        background: #F1F3F3;
                        border-radius: 2px;
                        padding: 0 12px;
                        box-sizing: border-box;

                        &::placeholder {                       
                            color: #B9C3C3;
                        }
                    }
                }

                .center-container { 
                    flex: 1;
                    min-height: 0;
                    width: 100%;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 6px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: #B9C3C3;
                        border-radius: 3px;
                        opacity: 0.5;
                    }

                    .writeContent {
                        width: 100%;
                        height: 100%;
                        outline: none;
                        border: none;
                        padding: 17px 20px;
                        box-sizing: border-box;
                    }
                    // background: #FCFEFF;
                }

                .bottom-container {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    height: 58px;
                    background: #FFFFFF;
                    box-shadow: -4px -4px 10px 0px rgba(5,10,15,0.05);
                    border-radius: 4px 4px 0px 0px;
                    padding: 0 22px 0 20px;
                    box-sizing: border-box;

                    .left-container {
                        display: flex;
                        flex-direction: row;
                        align-items: center;

                        .speed {
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            margin-right: 50px;
        
                            p {
                                font-size: 14px;
                                color: #050F0F;
                                line-height: 20px;
                                font-weight: 500;

                                &:nth-of-type(1) {
                                    min-width: 60px;
                                }
                            }
        
                            .speedList {
                                position: relative;
                                margin: 0 8px;
        
                                .speedInput {
                                    display: flex;
                                    flex-direction: row;
                                    justify-content: space-between;
                                    align-items: center;
                                    width: 60px;
                                    height: 30px;
                                    line-height: 30px;
                                    background: #F1F3F3;
                                    border-radius: 2px;
                                    padding: 0 6px 0 12px;
                                    user-select: none;
                                    cursor: pointer;

                                    span {
                                        font-size: 14px;
                                    }
                                }
        
                                ul {
                                    position: absolute;
                                    top: -160px;
                                    left: -9px;
                                    z-index: 1;
                                    display: flex;
                                    flex-direction: column;
                                    width: 78px;
                                    background: #FFFFFF;
                                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                                    border-radius: 4px;
                                    // display: none;
        
                                    li {
                                        width: 100%;
                                        height: 30px;
                                        line-height: 30px;
                                        font-size: 12px;
                                        color: #050F0F;
                                        text-align: center;
                                        user-select: none;
                                        cursor: pointer;
        
                                        &:hover {
                                            background: rgba(65, 180, 140, 0.15);
                                        }
                                    }
                                }
                            }
                        }

                        .btnList {
                            display: flex;
                            flex-direction: row;
                            align-items: center;

                            &>div {
                                margin-right: 20px;

                                &:nth-last-of-type(1) {
                                    margin-right: 6px;
                                }
                            }

                            .insertStop {
                                position: relative;

                                div {
                                    width: 78px;
                                    height: 30px;
                                    background: rgba(185, 195, 195, 0.2);
                                    border-radius: 4px;
                                    border: 1px solid #DCDCDC;
                                    font-size: 14px;
                                    color: #050F0F;
                                    line-height: 30px;
                                    text-align: center;
                                    user-select: none;
                                    cursor: pointer;

                                    &.on {
                                        color: #41B48C;
                                        background: #E6F1ED;
                                        border: 1px solid #41B48C;
                                    }
                                }

                                ul {
                                    position: absolute;
                                    top: -160px;
                                    left: 0px;
                                    display: flex;
                                    flex-direction: column;
                                    width: 78px;
                                    background: #FFFFFF;
                                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                                    border-radius: 4px;
                                    // display: none;
        
                                    li {
                                        width: 100%;
                                        height: 30px;
                                        line-height: 30px;
                                        font-size: 12px;
                                        color: #050F0F;
                                        text-align: center;
                                        user-select: none;
                                        cursor: pointer;
        
                                        &:hover {
                                            background: rgba(65, 180, 140, 0.15);
                                        }
                                    }
                                }
                            }

                            .insertWord {
                                position: relative;

                                div {
                                    width: 93px;
                                    height: 30px;
                                    background: rgba(185, 195, 195, 0.2);
                                    border-radius: 4px;
                                    border: 1px solid #DCDCDC;
                                    font-size: 14px;
                                    color: #050F0F;
                                    line-height: 30px;
                                    text-align: center;
                                    user-select: none;
                                    cursor: pointer;

                                    &.on {
                                        color: #41B48C;
                                        background: #E6F1ED;
                                        border: 1px solid #41B48C;
                                    }
                                }
                            }

                            .insertNum {
                                position: relative;

                                &>div:nth-of-type(1) {
                                    width: 78px;
                                    height: 30px;
                                    background: rgba(185, 195, 195, 0.2);
                                    border-radius: 4px;
                                    border: 1px solid #DCDCDC;
                                    font-size: 14px;
                                    color: #050F0F;
                                    line-height: 30px;
                                    text-align: center;
                                    user-select: none;
                                    cursor: pointer;

                                    &.on {
                                        color: #41B48C;
                                        background: #E6F1ED;
                                        border: 1px solid #41B48C;
                                    }
                                }

                                &>ul {
                                    position: absolute;
                                    top: -70px;
                                    left: 0px;
                                    display: flex;
                                    flex-direction: column;
                                    width: 78px;
                                    background: #FFFFFF;
                                    box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                                    border-radius: 4px;
                                    // display: none;
        
                                    li {
                                        width: 100%;
                                        height: 30px;
                                        line-height: 30px;
                                        font-size: 12px;
                                        color: #050F0F;
                                        text-align: center;
                                        user-select: none;
                                        cursor: pointer;
        
                                        &:hover {
                                            background: rgba(65, 180, 140, 0.15);
                                        }
                                    }
                                }
                            }

                            .help {
                                position: relative;

                                i {
                                    display: block;
                                    width: 16px;
                                    height: 16px;
                                    background: url('../assets/img/anchor/help.png') no-repeat;
                                    background-position: center center;
                                    background-size: 100% 100%;
                                    cursor: pointer;

                                    &:hover {
                                        background: url('../assets/img/anchor/helpOn.png') no-repeat;

                                        &+.content {
                                            display: flex;
                                        }
                                    }
                                }

                                .content {
                                    display: none;
                                    flex-direction: column;
                                    position: absolute;
                                    top: -70px;
                                    left: 50%;
                                    z-index: 2;
                                    width: 228px;
                                    height: 54px;
                                    background: rgba(30,39,34,0.89);
                                    padding: 6px 12px;
                                    border-radius: 4px;
                                    box-sizing: border-box;
                                    margin-left: -114px;

                                    img {
                                        position: absolute;
                                        bottom: -9px;
                                        left: 50%;
                                        margin-left: -8px;
                                        transform: rotate(180deg);
                                    }

                                    span:nth-of-type(1) {
                                        font-size: 12px;
                                        line-height: 20px;
                                        color: #41B48C;
                                        font-weight: bold;
                                    }

                                    span:nth-of-type(2) {
                                        font-size: 12px;
                                        line-height: 20px;
                                        color: #FFF;
                                        font-weight: bold;
                                    }
                                }
                            }

                            .line {
                                width: 1px;
                                height: 20px;
                                background: #DCDCDC;
                                margin: 0 20px;
                            }
                        }
                    }

                    .right-container {
                        display: flex;
                        align-items: center;

                        i {
                            display: block;
                            width: 16px;
                            height: 16px;
                            background: url('../assets/img/anchor/noticeOn.png') no-repeat;
                            background-position: center center;
                            background-size: 100% 100%;
                            cursor: pointer;
                            margin-right: 6px;

                            // &:hover {
                            //     background: url('../assets/img/anchor/noticeOn.png') no-repeat;
                            
                            //     &+.content {
                            //         display: flex;
                            //     }
                            // }
                        }

                        .content {
                            font-size: 12px;
                            color: #41B48C;
                        }

                        .submit {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 88px;
                            height: 32px;
                            background: #41B48C;
                            border-radius: 4px;
                            cursor: pointer;
                            border: 1px solid #41B48C;
                            box-sizing: border-box;
                            margin-left: 10px;

                            i {
                                display: block;
                                width: 16px;
                                height: 14px;
                                background: url('../assets/img/voiceCompose/compose.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                                margin-right: 6px;
                            }

                            span {
                                font-size: 14px;
                                color: #FFFFFF;
                            }
                        }

                        .save {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 88px;
                            height: 32px;
                            border-radius: 4px;
                            cursor: pointer;
                            border: 1px solid #41B48C;
                            box-sizing: border-box;
                            margin-left: 10px;

                            i {
                                display: block;
                                width: 16px;
                                height: 16px;
                                background: url('../assets/img/voiceCompose/save.png') no-repeat;
                                background-position: center center;
                                background-size: 100% 100%;
                            }

                            span {
                                font-size: 14px;
                                color: #41B48C;
                            }
                        }
                    }
                }
            }
        }

        .wordInput-bg {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(50, 59, 75, 0.3);
            backdrop-filter: blur(1.6px);

            .wordInput-container {
                position: absolute;
                top: 50%;
                left: 50%;
                z-index: 999999;
                // margin-left: -215px;
                // margin-top: -96px;
                transform: translate(-50%, -50%);
                display: flex;
                flex-direction: column;
                width: 430px;
                max-height: 284px;
                background: #FFFFFF;
                box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.1);
                border-radius: 4px;
                padding: 20px 30px;
                box-sizing: border-box;

                &>p {
                    font-size: 16px;
                    line-height: 24px;
                    color: #000000;
                    font-weight: bold;
                    margin-bottom: 24px;
                }

                .input-container {
                    display: flex;
                    flex-direction: column;
                    width: 100%;
                    max-height: 138px;
                    overflow-y: auto;

                    &::-webkit-scrollbar {
                        width: 4px;
                    }
                    &::-webkit-scrollbar-thumb {
                        background: rgba(#dcdcdc, 1);
                        border-radius: 4px;
                    }
                }

                .input {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    margin-bottom: 14px;

                    &>span {
                        font-size: 14px;
                        color: #050F0F;
                    }

                    input {
                        width: 234px;
                        height: 32px;
                        line-height: 32px;
                        background: #F1F3F3;
                        border-radius: 2px;
                        border: none;
                        padding: 0 12px;
                        font-size: 14px;
                    }

                    .sb {
                        // position: relative;
                        p {
                            display: flex;
                            flex-direction: row;
                            justify-content: center;
                            align-items: center;
                            width: 88px;
                            height: 32px;
                            background: #F1F3F3;
                            border-radius: 2px;

                            &.on {
                                border: 1px solid #41B48C;
                                box-sizing: border-box;
                            }

                            span {
                                display: block;
                                flex: 1;
                                height: 100%;
                                line-height: 32px;
                                text-align: center;
                                font-size: 14px;
                                color: #050F0F;
                            }

                            img {
                                user-select: none;
                                cursor: pointer;
                            }
                        }

                        &>ul {
                            position: absolute;
                            // top: 40px;
                            // left: 0px;
                            margin-top: 10px;
                            z-index: 9;
                            display: flex;
                            flex-direction: column;
                            width: 88px;
                            background: #FFFFFF;
                            box-shadow: 4px 4px 10px 0px rgba(5, 10, 15, 0.05);
                            border-radius: 4px;
                            // display: none;

                            li {
                                width: 100%;
                                height: 30px;
                                line-height: 30px;
                                font-size: 12px;
                                color: #050F0F;
                                text-align: center;
                                user-select: none;
                                cursor: pointer;

                                &:hover {
                                    background: rgba(65, 180, 140, 0.15);
                                }
                            }
                        }
                    }
                }

                .btn {
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    margin-top: 16px;

                    p {
                        width: 88px;
                        height: 32px;
                        line-height: 32px;
                        text-align: center;
                        border-radius: 4px;
                        border: 1px solid #B9C3C3;
                        font-size: 14px;
                        color: #262626;
                        margin-right: 10px;
                        box-sizing: border-box;
                        user-select: none;
                        cursor: pointer;

                        &.on {
                            background: #41B48C;
                            border: 1px solid #41B48C;
                            box-sizing: border-box;
                            color: #FFFFFF;
                        }

                        &.op {
                            opacity: 0.5;
                        }
                    }
                }
            }
        }
    }
</style>